export default __webpack_public_path__ + "static/760-0df763be06c1521555a684253769b768.gif";